import { Experiments } from 'CustomOptimizelyProvider'
import {
  AMOUNT_PREMIUM_THRESHOLD,
  INCOME_PREMIUM_THRESHOLD
} from 'constants/components'
import { PossibleVariants } from 'utils/tracking/optimizely/types'
import { CAT_4784_PREMIUM_AMOUNT_THRESHOLD } from 'utils/userState'
import type { GateContext } from '../gates.types'

type Cat4784Context = Pick<GateContext, 'experimentData' | 'tenant'>

export const isCat4784SmavaExperiment = ({
  experimentData,
  tenant
}: Cat4784Context): boolean =>
  tenant === 'smava' &&
  [PossibleVariants.CONTROL, PossibleVariants.VARIATION_B].includes(
    experimentData[Experiments.CAT_4784_DAC_SKIP_BUTTON_V5] as PossibleVariants
  )

export const isCat4784SmavaDacSkipButtonVarB = ({
  experimentData,
  tenant
}: Cat4784Context): boolean =>
  tenant === 'smava' &&
  experimentData[Experiments.CAT_4784_DAC_SKIP_BUTTON_V5] ===
    PossibleVariants.VARIATION_B

export const isCat4784SmavaPremiumExcluded = (context: GateContext): boolean =>
  isCat4784SmavaExperiment(context) &&
  (context.isYoungAge || context.isMiddleAge) &&
  context.amount >= AMOUNT_PREMIUM_THRESHOLD &&
  context.amount < CAT_4784_PREMIUM_AMOUNT_THRESHOLD &&
  context.primaryIncome >= INCOME_PREMIUM_THRESHOLD
